module.exports = __webpack_public_path__ + "static/img/14000578.ff4c9ec0.png";